import React, { useMemo } from "react";
import { VsiBubbleFavs } from "../styled/App.styled";
import { useDataWithRoute } from "../utils/hooks";
import { Row, Col, Spinner } from "reactstrap";
import Stockchart from "../components/Stockchart";
import PieChart from "../components/PieChart";
import { formatStockChartConfig, snakeCaseToTitleCase } from "../utils/Helpers";
import { useVsiAppContext } from "../stores/VsiApp";

const errorFields = ["buffer_credit", "link_failure", "crc_errors", "link_reset", "loss_of_sync_signal", "free_ports"];

const mungePie = data => {
  const keys = ["free_ports", "used_ports", "unlicensed_ports"];
  const dict = {};

  data.forEach(datum => {
    keys.forEach(key => {
      if (!dict.hasOwnProperty(key)) {
        dict[key] = 0;
      }
      dict[key] += datum?.[key] || 0;
    });
  });

  return keys.map(key => ({
    name: snakeCaseToTitleCase(key),
    y: dict[key]
  }));
};

export default function SwitchesSummary() {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("SAN-SWITCH");

  const route = useMemo(() => `/api/v6/report/enterprise_switch_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordsets }, { isLoading }] = useDataWithRoute(route);
  const [rawPieData, rawPortData] = useMemo(() => {
    return recordsets || [[], []];
  }, [recordsets]);

  const { pieData, portTrendData } = useMemo(() => {
    const allDates = {};
    const findSwitches = {};
    (rawPortData || []).forEach(datum => {
      if (!allDates.hasOwnProperty(datum.collection_date)) {
        allDates[datum.collection_date] = { ...datum };
      } else {
        errorFields.forEach(field => {
          allDates[datum.collection_date][field] = parseInt(allDates?.[datum.collection_date]?.[field] || 0) + parseInt(datum?.[field] || 0);
        });
      }

      if (!findSwitches[datum.global_name]) {
        findSwitches[datum.global_name] = true;
      }
    });

    const fieldsSwitches = Object.keys(findSwitches).map(sanSwitch => ({
      name: sanSwitch,
      field: "free_ports"
    }));

    const allPortsTrends = formatStockChartConfig(rawPortData || [], fieldsSwitches, "global_name");

    return {
      pieData: {
        name: "Ports",
        colorByPoint: true,
        data: mungePie(rawPieData)
      },
      portTrendData: allPortsTrends.series
    };
  }, [rawPortData, rawPieData]);

  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <Row>
      <Col xs={12} lg={6}>
        <VsiBubbleFavs>
          <PieChart
            title={"Ports"}
            height={420}
            series={pieData}
            disableLabels={true}
            includeLegend={false} />
        </VsiBubbleFavs>
      </Col>
      <Col xs={12} lg={6}>
        <VsiBubbleFavs>
          <Stockchart config={{
            yAxis: {
              title: {
                text: "Free Ports"
              }
            }
          }} series={portTrendData} height={420} navDisabled={true} />
        </VsiBubbleFavs>
      </Col>
    </Row>
  );
}